//Stateler çekilip return edilecek

export const getDefinationLoading = (state) => {
  return state.loading
}

export const getCountries = (state) => {
  return state.countries
}

export const getCities = (state) => {
  return state.cities
}

export const getTowns = (state) => {
  return state.towns
}

export const getAddressStatus = (state) => {
  return state.status
}

export const getStatus = (state) => {
  return state.status
}

export const getSubscriptions = (state) => {
  return state.subscriptions
}

export const getAccountTypes = (state) => {
  return state.accountTypes
}

export const getJobs = (state) => {
  return state.jobs
}

export const getZoneTypes = (state) => {
  return state.zoneTypes
}

export const getBrands = (state) => {
  return state.brands
}

export const getModels = (state) => {
  return state.models
}

export const getProtocols = (state) => {
  return state.protocols
}

export const getEventCodesPageInfo = (state) => {
  return state.eventCodesPageInfo
}

export const getTasks = (state) => {
  return state.tasks
}

export const getSignalGroups = (state) => {
  return state.signalGroups
}

export const getSignalTypes = (state) => {
  return state.signalTypes
}

export const getQuickNotes = (state) => {
  return state.quickNotes
}

export const getProducts = (state) => {
  return state.products
}

export const getStockMovementTypes = (state) => {
  return state.stockMovementTypes
}

export const getFaultSupportPieces = (state) => {
  return state.faultSupportPieces
}

export const getFaultSupportResults = (state) => {
  return state.faultSupportResults
}

export const getImportantNumbers = (state) => {
  return state.importantNumbers
}

export const getVacations = (state) => {
  return state.vacations
}

export const getVacation = (state) => {
  return state.vacation
}

export const getVacationJobs = (state) => {
  return state.vacationJobs
}

export const getEvaluationResults = (state) => {
  return state.evaluationResults
}

export const getEventCodes = (state) => {
  return state.eventCodes
}

export const getProductsPageInfo = (state) => {
  return state.productsPageInfo
}

export const getSystemModules = (state) => {
  return state.systemModules
}

export const getSystemMenus = (state) => {
  return state.systemMenus
}

export const getCustomFields = (state) => {
  return state.customFields
}

export const getForms = (state) => {
  return state.forms
}

export const getFormCustomFields = (state) => {
  return state.formCustomFields
}

export const getTicketStatuses = (state) => {
  return state.ticketStatus
}
export const getReceivers = (state) => {
  return state.receivers
}
export const getReceiverDetail= (state) => {
  return state.receiverDetail
}
export const getReceiverProtocols= (state) => {
  return state.receiverProtocols
}
export const getProtocolFormats= (state) => {
  return state.formats
}

export const getDeviceTypes = (state) => {
  return state.deviceTypes
}
export const getConstants = (state) => {
  return state.constants
}



// WEBPACK FOOTER //
// ./src/store/modules/Defination/Getters.js